import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {API, DeviceLogDTO} from 'src/app/services/api/api';
import {ErrorService} from 'src/app/services/error.service';
import {UtilService} from 'src/app/services/util.service';
import {SbDateTime} from '../../../../services/api/api-date-time';

@Component({
  selector: 'sb-device-log',
  templateUrl: './sb-device-log.component.html',
  styleUrls: ['./sb-device-log.component.scss'],
  standalone: false,
})
export class SbDeviceLogComponent extends DataSource<DeviceLogDTO | undefined> implements OnInit, OnChanges {
  @Input() deviceId: number;
  @Input() date: SbDateTime;
  @Input() logdatatypes: { id: string }[];

  placeholderHeight = 0;
  displayedColumns: string[] = ['id', 'timestamp', 'datatype', 'value', 'causedBy'];

  private cachedLogs = Array.from<DeviceLogDTO>({ length: 0 });
  private dataStream = new BehaviorSubject<(DeviceLogDTO | undefined)[]>(this.cachedLogs);
  private subscription = new Subscription();

  private pageSize = 10;
  private lastPage = 0;

  loading: boolean = true;

  requesting: boolean = false;

  constructor(
    private api: API,
    public util: UtilService,
    public errorHandler: ErrorService
  ) {
    super();
  }

  ngOnInit(): void {
    this._fetchPage(null);
  }

  placeholderWhen(index: number, _: any) {
    return index === 0;
  }

  clear() {
    this.lastPage = 0;
    this.cachedLogs = Array.from<DeviceLogDTO>({ length: 0 });
    this.dataStream.next(this.cachedLogs);
  }

  connect(collectionViewer: CollectionViewer): Observable<(DeviceLogDTO | undefined)[] | ReadonlyArray<DeviceLogDTO | undefined>> {
    return this.dataStream;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subscription.unsubscribe();
  }

  private _fetchPage(rangeEnd: number): void {
    if (!this.requesting) {
      this.requesting = true;
      let after: number;

      if (rangeEnd && this.cachedLogs && this.cachedLogs.length > 0) {
        after = this.cachedLogs[this.cachedLogs.length - 1].id;
      } else {
        after = null;
      }

      const dtypes: string[] = [];

      if (this.logdatatypes?.length > 0) {
        for (const dtypeobj of this.logdatatypes) {
          if (dtypeobj?.id) {
            dtypes.push(dtypeobj.id);
          }
        }
      }

      this.api
        .ss_nm_Device_logs(this.deviceId, {
          after,
          count: this.pageSize,
          till: this.date,
          datatype: dtypes?.length > 0 ? dtypes : undefined,
        })
        .subscribe(
          (res: DeviceLogDTO[]) => {
            this.cachedLogs = this.cachedLogs.concat(res);
            this.dataStream.next(this.cachedLogs);
            if (!res || !res.length || res.length === 0 || res.length < this.pageSize) {
              this.loading = false;
            }
            this.requesting = false;
          },
          error => {
            this.errorHandler.errorHandler(error);
            this.requesting = false;
          }
        );
    }
  }

  private _getPageForIndex(i: number): number {
    return Math.floor(i / this.pageSize);
  }

  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight; // viewport: ~500px
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 1;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit) {
      this.loading = true;
      this._fetchPage(1337);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    let dirty: boolean = false;
    if (changes.date) {
      this.date = changes.date.currentValue;
      dirty = true;
    }

    if (changes.logdatatypes) {
      this.logdatatypes = changes.logdatatypes.currentValue;
      dirty = true;
    }

    if (dirty) {
      this.cachedLogs = [];
      this._fetchPage(null);
    }
  }
}
